import { Component } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  selector: "app-loading-section",
  imports: [MatProgressSpinnerModule],
  templateUrl: "./loading-section.component.html",
  styleUrl: "./loading-section.component.scss",
})
export class LoadingSectionComponent {}
